import {HttpError} from "./http-error";

/**
 * The lock was held by somebody else, so nothing was written (HTTP 409).
 *
 * A TYPE MARKER, carrying no data of its own: the backend body for a conflict is
 * `{success: false, error: {code, message}}` and the error handler is
 * deliberately left unchanged, so there is no holder in the response to read.
 * Inventing a field for one would be inventing a value nothing populates — the
 * holder's name is resolved separately, from the refreshed row.
 *
 * IT EXTENDS `HttpError`, NOT `Error`, AND THAT IS LOAD-BEARING. The Linkview
 * repository recognises a rejected tile save with
 * `error instanceof HttpError && error.status === 409`. A bare `Error` subclass
 * here would silently stop matching that check: the conflict would fall into the
 * generic branch, be reported as a server error rather than a lost lock, and the
 * baseline refresh, stale-target refusal and queue discard behind it would never
 * run. Nothing would fail loudly — the save would simply start lying about why
 * it failed. `instanceof Error` still holds transitively, so every existing
 * generic catch keeps working.
 */
export class LockConflictError extends HttpError {

    public constructor(message: string) {
        super(message, 409);
        this.name = 'LockConflictError';
    }

}
